import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { resolveAudienceDisplayName } from '../utils/audience-display.util';

@Pipe({
    name: 'audienceDisplayName',
    pure: false,
})
export class AudienceDisplayNamePipe implements PipeTransform {
    constructor(private _translateService: TranslateService) {}

    transform(name: string | null | undefined): string {
        return resolveAudienceDisplayName(name, (key) => this._translateService.instant(key));
    }
}
